import React from 'react'
import "./Chip.css"

function Chip({ text }) {
  return (
    <div className={"chip__main"}>{text}</div>
  )
}

export default Chip


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Chip/Chip.js